export const EDIT_STARTUP_PROFILE = "editStartupProfile";
